var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",style:(`height: ${_vm.wrapperHeight}`)},[_c('van-loading',{attrs:{"color":"#1989fa"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }